export const TICKET_DELETE_RESET = 'TICKET_DELETE_RESET'
export const TICKET_DELETE_SET_ERROR = 'TICKET_DELETE_SET_ERROR'
export const TICKET_DELETE_SET_DELETED = 'TICKET_DELETE_SET_DELETED'
export const TICKET_DELETE_TOGGLE_LOADING = 'TICKET_DELETE_TOGGLE_LOADING'
